module.exports = __webpack_public_path__ + "r-v3/img/ico_plus_white.8e6a295a.svg";